"use client";
import { containerVariants, itemVariants } from '@/lib/utils/util';
import { motion } from 'framer-motion'
import { useTranslations } from 'next-intl';
import React from 'react'

function VissonCard() {
    const t = useTranslations();

  return (
        <div 
            id="vision-mission"
            className="py-8 sm:py-12 md:py-16 relative overflow-hidden bg-mainColor scroll-mt-40"
            style={{
              backgroundImage: `
                linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px),
                linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
                linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
                linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px),
                radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.15) 1px, transparent 0)
              `,
              backgroundSize: '60px 60px, 60px 60px, 20px 20px, 20px 20px, 60px 60px',
              backgroundPosition: '0 0, 0 0, 0 0, 0 0, 0 0'
            }}
        >
            {/* Decorative gradient overlay */}
            <div className="absolute inset-0 opacity-30 pointer-events-none" style={{
              background: 'radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.08) 0%, transparent 50%)'
            }}></div>
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
              variants={containerVariants}
              className="container mx-auto px-4 sm:px-6 relative z-10"
            >
              {/* Header Section with Dark Blue Background */}
              <motion.div
                variants={itemVariants}
                className="text-center mb-6 sm:mb-8 md:mb-10"
              >
                <h2 className="text-2xl sm:text-3xl xl:text-4xl font-bold text-white leading-tight px-2">
                  {t('plsyy.visionExcellenceTitle')}
                </h2>
              </motion.div>
  
              {/* Three Cards Section */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
                {/* Mission Card */}
                <motion.div
                  variants={itemVariants}
                  className="p-4 sm:p-6 md:p-8 bg-white shadow-md hover:shadow-lg transition-all duration-300 hover:bg-black group"
                >
                  <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                    <img 
                      src="/icon/mission.svg" 
                      alt="Mission" 
                      className="w-10 h-10 sm:w-12 sm:h-12 object-contain group-hover:brightness-0 group-hover:invert transition-all duration-300 flex-shrink-0"
                    />
                    <h3 className="text-lg sm:text-xl font-bold text-mainColor group-hover:text-white transition-colors duration-300">{t('plsyy.missionCardTitle')}</h3>
                  </div>
                  <div className="h-[1px] bg-gray-200 my-3 sm:my-4"></div>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed group-hover:text-white transition-colors duration-300">{t('plsyy.missionCardDesc')}</p>
                </motion.div>
  
                {/* Vision Card */}
                <motion.div
                  variants={itemVariants}
                  className="p-4 sm:p-6 md:p-8 bg-white shadow-md hover:shadow-lg transition-all duration-300 hover:bg-black group"
                >
                  <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                    <img 
                      src="/icon/vision.svg" 
                      alt="Vision" 
                      className="w-10 h-10 sm:w-12 sm:h-12 object-contain group-hover:brightness-0 group-hover:invert transition-all duration-300 flex-shrink-0"
                    />
                    <h3 className="text-lg sm:text-xl font-bold text-mainColor group-hover:text-white transition-colors duration-300">{t('plsyy.visionCardTitle')}</h3>
                  </div>
                  <div className="h-[1px] bg-gray-200 my-3 sm:my-4"></div>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed group-hover:text-white transition-colors duration-300">{t('plsyy.visionCardDesc')}</p>
                </motion.div>
  
                {/* Strategic Objective Card */}
                <motion.div
                  variants={itemVariants}
                  className="p-4 sm:p-6 md:p-8 bg-white shadow-md hover:shadow-lg transition-all duration-300 hover:bg-black group"
                >
                  <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                    <img 
                      src="/icon/strategic.svg" 
                      alt="Strategic Objective" 
                      className="w-10 h-10 sm:w-12 sm:h-12 object-contain group-hover:brightness-0 group-hover:invert transition-all duration-300 flex-shrink-0"
                    />
                    <h3 className="text-lg sm:text-xl font-bold text-mainColor group-hover:text-white transition-colors duration-300">{t('plsyy.strategicObjectiveTitle')}</h3>
                  </div>
                  <div className="h-[1px] bg-gray-200 my-3 sm:my-4"></div>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed group-hover:text-white transition-colors duration-300">{t('plsyy.strategicObjectiveDesc')}</p>
                </motion.div>
              </div>
  
            </motion.div>
          </div>
  )
}

export default VissonCard